<template>
    <div id="first-strategy" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="200">
        <!--=====================================-->
        <!--=      Strategy Quality Area Start    =-->
        <!--=====================================-->
        <section class="section bg-color-light-gray pb--80 pb_lg--40 pb_md--20">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="about-quality active mb--10">
                            <h3 class="sl-number bold mb-2 mt-5">1</h3>
                            <h2 class="title black font-weight-100 mb-2 ml-1">
                                Financiamiento <span class="bold">directo</span>.
                            </h2>
                            <p class="black">
                                Tenemos el objetivo de ser el principal medio por el cual la sociedad mexicana invierte para promover la sostenibilidad.
                            </p>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 mb-4">
                        <div class="strategy-card p-5" :style="`background-image: url(${img2}) !important;`">
                            <h5 class="primary bold mb-3">Financiamiento climático.</h5>
                            <p class="font-weight-100 mb-1">
                                Créditos dirigidos a las principales fuentes de emisión 
                                de gases de efecto invernadero: agronegocios, conservación, 
                                construcción, energía, movilidad y residuos.
                            </p>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6 mb-4">
                        <div class="strategy-card p-5" :style="`background-image: url(${img1}) !important;`">
                            <h5 class="primary bold mb-3">Financiamiento con enfoque social.</h5>
                            <p class="font-weight-100 mb-1">
                                Créditos enfocados en brindar inclusión financiera 
                                y bienestar para las familias mexicanas: educación, 
                                estrés financiero, micronegocio, vivienda, salud.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>

export default {
    name: "FirstStrategy",
    components: {
    },
    data() {
        return  {
            img1: "https://cdn.redgirasol.com/nuevo_portal/fotografias/strategy-human.png",
            img2: "https://cdn.redgirasol.com/nuevo_portal/fotografias/strategy-tree.png"
        }
    }
}

</script>

<style scoped>
.about-quality .sl-number {
    background: var(--color-primary);
}

.strategy-card {
    padding: 2rem;
    background-color: var(--color-black);
    color: #FFF;
    border-radius: 25px;
    min-height: 15rem;
    background-position-y: center;
    background-position-x: center;
}
</style>